import './NavbarLayout.css';

import React from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Navbar } from './navbar';

/**
 * Creates a layout that includes a top navbar.
 *
 * @param {import('@src/app_router/getNavigationLinks').NavigationLink[]} navigationLinks Array of navigation links
 * @returns {JSX.Element} The NavbarLayout React component.
 */
export const NavbarLayout = ({ navigationLinks }) => {
  return (
    <div id="navbar-layout">
      <div id="navbar-layout-navbar">
        <Navbar navigationLinks={navigationLinks} />
      </div>
      <div id="navbar-layout-content">
        <Outlet />
      </div>
    </div>
  );
};

NavbarLayout.propTypes = {
  navigationLinks: PropTypes.arrayOf(PropTypes.object),
};
